
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.948 5.373H3.058C1.37 5.373 0 6.715 0 8.366v12.641C0 22.658 1.371 24 3.057 24h18.886C23.629 24 25 22.658 25 21.007V8.371c.005-1.65-1.366-2.998-3.052-2.998zm1.66 15.634c0 .897-.744 1.626-1.66 1.626H3.058c-.916 0-1.661-.73-1.661-1.626V8.371c0-.896.745-1.625 1.66-1.625h18.886c.916 0 1.66.729 1.66 1.625v12.636h.006z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.769 14.53l6.114-5.368a.677.677 0 00.052-.967.712.712 0 00-.988-.051l-8.432 7.41-1.645-1.439c-.005-.005-.01-.01-.01-.015a1.011 1.011 0 00-.114-.096L4.052 8.139a.708.708 0 00-.988.056.673.673 0 00.057.967l6.187 5.414-6.16 5.647a.676.676 0 00-.032.967.708.708 0 00.988.035l6.254-5.727 1.697 1.484a.707.707 0 00.93-.005l1.744-1.53 6.218 5.784c.134.126.31.187.48.187.187 0 .368-.07.508-.213a.676.676 0 00-.026-.967l-6.14-5.708z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.948 0H8.058C6.37 0 5 1.342 5 2.993v.679h1.397v-.674c0-.896.745-1.626 1.66-1.626h18.886c.916 0 1.66.73 1.66 1.626v12.636h.006c0 .896-.745 1.626-1.66 1.626h-.699v1.367h.693c1.687 0 3.057-1.342 3.057-2.993V2.998C30.006 1.348 28.635 0 26.948 0z","fill":"currentColor"}})])
          )
        }
      }
    